import React from "react"
import Typography from "@mui/material/Typography"

const PriceTypography = ({ children, isNull, ...rest }) => {
  if (isNull) return null
  return (
    <Typography
      {...rest}
      sx={{
        opacity: 0.5,
        textDecoration: "line-through",
      }}
    >
      {children}
    </Typography>
  )
}

export default PriceTypography
